import { DealerWiseTopBuyRptConstants } from '../constants';
export function  DealerWiseTopBuyRpt(state = {}, action) {
    switch (action.type) {
        case DealerWiseTopBuyRptConstants.LOADING_REQUEST:
            return {
                ...state,
                loading: action.isbool
            };
        case DealerWiseTopBuyRptConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case DealerWiseTopBuyRptConstants.GETALL_SUCCESS:
            return {
                ...state,
                items: action.datas
            };
        case DealerWiseTopBuyRptConstants.GETALL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case DealerWiseTopBuyRptConstants.GETEXPORT_REQUEST:
            return {
                ...state,
                exporting: true
            };
        case DealerWiseTopBuyRptConstants.GETEXPORT_SUCCESS:
            return {
                ...state,
                exportitems: action.datas
            };
        case DealerWiseTopBuyRptConstants.GETEXPORT_FAILURE:
            return {
                ...state,
                error: action.error
            };
        default:
            return state
    }

}